import axios from './axios';

export const fetchSeriesVariationRates = async (seriesID) => {
    const response = await axios.get(`/seriesVariationRate/series/${seriesID}`);
    return response.data;
};

export const createSeriesVariationRate = async (data) => {
    const response = await axios.post('/seriesVariationRate', data);
    return response.data;
};

export const updateSeriesVariationRate = async (id, data) => {
    const response = await axios.put(`/seriesVariationRate/${id}`, data);
    return response.data;
};

export const deleteSeriesVariationRate = async (id) => {
    const response = await axios.delete(`/seriesVariationRate/${id}`);
    return response.data;
};
